import { Experiment, ExperimentClient } from '@amplitude/experiment-js-client'
import { getBrandConfig } from '@/config/config'

let experiment: ReturnType<
  typeof Experiment.initializeWithAmplitudeAnalytics
> | null = null
let fetchPromise: Promise<ExperimentClient> | null = null

const getExperiment = () => {
  if (!experiment) {
    const config = getBrandConfig()
    experiment = Experiment.initializeWithAmplitudeAnalytics(
      config.amplitude.deploymentKey,
      {
        fetchOnStart: false,
        serverZone: config.amplitude.region,
      },
    )
  }

  return experiment
}

export const getFeatureFlag = async ({
  userId,
  flagKey,
}: {
  userId?: string
  flagKey: string
}) => {
  const exp = getExperiment()

  if (userId) {
    exp.setUser({ user_id: userId })
  }

  if (!fetchPromise) {
    fetchPromise = exp.fetch()
  }

  await fetchPromise

  const variant = exp.variant(flagKey)

  return {
    enabled: variant?.value === 'on',
    variant,
  }
}
